import { useState } from "react";
import { CompanyInboxConfirm } from "./CompanyInboxConfirm";
import { InboxDocumentPreview } from "./InboxDocumentPreview";

export function CompanyUploadedReview({ ids, onFinished, compact = false }: { ids: string[]; onFinished: () => void; compact?: boolean }) {
  const [remaining, setRemaining] = useState(ids);
  const active = remaining[0];
  if (!active) return null;
  return <div className={`flex min-h-0 flex-1 flex-col gap-3 ${compact ? "" : "lg:grid lg:grid-cols-2"}`}>
    <div className="avm-surface flex min-h-0 flex-1 flex-col rounded border bg-background">
      <p className="shrink-0 border-b p-3 text-sm">Preostalo za potvrdu: {remaining.length}</p>
      <CompanyInboxConfirm key={active} id={active} onClose={onFinished} onComplete={(id) => { const next = remaining.filter((item) => item !== id); setRemaining(next); if (!next.length) onFinished(); }} />
    </div>
    <section aria-label="Pregled učitanog dokaza" className={`${compact ? "max-h-56 shrink-0" : "min-h-0 flex-1"} flex flex-col rounded border bg-background p-3`}>
      <InboxDocumentPreview key={active} id={active} company />
    </section>
  </div>;
}
